import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { getAgent } from "../../services/agent.service";
import { useSelector } from "react-redux";

export default function AgentDetails() {
  const { token } = useSelector((state) => state?.auth);
  const [agent, setAgent] = useState([]);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const agentID = params.get("id");

  const fetchAgent = async () => {
    try {
      const res = await getAgent(token, agentID);

      if (res && res.status >= 200 && res.status < 300) {
        setAgent(res?.data);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch agent details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching main agent:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the agent. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (agentID) {
      fetchAgent();
    }
  }, [agentID]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Agent Details</h4>
                <Link to="/agent">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* Agent Name */}
                  <div className="col-sm-6 mb-4">
                    <h5>Agent Name</h5>
                    <p>{agent?.fullname || "N/A"}</p>
                  </div>

                  {/* Agent Code */}
                  <div className="col-sm-6 mb-4">
                    <h5>Agent Code</h5>
                    <p>{agent?.user_code || "N/A"}</p>
                  </div>

                  {/* email */}
                  <div className="col-sm-6 mb-4">
                    <h5>Agent Email</h5>
                    <p>{agent?.email || "N/A"}</p>
                  </div>

                  {/* Phone No */}
                  <div className="col-sm-6 mb-4">
                    <h5>Phone Number</h5>
                    <p>{agent?.mobile_number || "N/A"}</p>
                  </div>

                  {/* Status */}
                  {/* <div className="col-sm-6 mb-4">
                    <h5>Status</h5>
                    <p>{agent?.status?.toString().toUpperCase()}</p>
                  </div> */}

                  {/* Agent address */}
                  <div className="col-sm-6 mb-4">
                    <h5>Address</h5>
                    <p>{agent?.agent_address || "N/A"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
